import {
  Box,
  Button,
  Card,
  CardContent,
  DialogTitle,
  Divider,
  Grid,
  Modal,
  Typography,
} from "@mui/material";
import { ModalHeader } from "../../common/modalHeader";
import { useEffect, useRef } from "react";
import CloseIcon from "@mui/icons-material/Close";
// import { htmlToPDF } from "../../common/printBillingApi.js";
import { useSelector } from "react-redux";
import html2pdf from "html2pdf.js";
export const EmployeeViewReceipt = ({ modalData, open, setOpen }) => {
  useEffect(() => {
    let data = modalData;
    console.log("openModal ", data);
  }, [modalData]);

  const actvieBussinessDetails = useSelector(
    (state) => state.reducer.actvieBussinessDetails
  );
  const receptRef = useRef(null);
  const convertNumberToWords = (amount) => {
    if (typeof amount !== "number") {
      amount = parseFloat(amount);
    }

    if (isNaN(amount)) return "Zero";

    const singleDigits = [
      "",
      "One",
      "Two",
      "Three",
      "Four",
      "Five",
      "Six",
      "Seven",
      "Eight",
      "Nine",
    ];
    const twoDigits = [
      "Ten",
      "Eleven",
      "Twelve",
      "Thirteen",
      "Fourteen",
      "Fifteen",
      "Sixteen",
      "Seventeen",
      "Eighteen",
      "Nineteen",
    ];
    const tensMultiple = [
      "",
      "",
      "Twenty",
      "Thirty",
      "Forty",
      "Fifty",
      "Sixty",
      "Seventy",
      "Eighty",
      "Ninety",
    ];
    const scales = ["", "Thousand", "Lakh", "Crore"];

    const numToWords = (num) => {
      let str = "";

      if (num > 99999999) {
        str += numToWords(Math.floor(num / 10000000)) + " Crore ";
        num %= 10000000;
      }
      if (num > 99999) {
        str += numToWords(Math.floor(num / 100000)) + " Lakh ";
        num %= 100000;
      }
      if (num > 999) {
        str += numToWords(Math.floor(num / 1000)) + " Thousand ";
        num %= 1000;
      }
      if (num > 99) {
        str += singleDigits[Math.floor(num / 100)] + " Hundred ";
        num %= 100;
      }
      if (num > 9 && num < 20) {
        str += twoDigits[num - 10] + " ";
      } else if (num > 0) {
        str +=
          tensMultiple[Math.floor(num / 10)] +
          (num % 10 !== 0 ? " " + singleDigits[num % 10] : "") +
          " ";
      }

      return str.trim();
    };

    const [integerPart, decimalPart] = amount.toFixed(2).toString().split(".");

    let result = numToWords(parseInt(integerPart));
    if (decimalPart && parseInt(decimalPart) > 0) {
      result +=
        " Point " +
        decimalPart
          .split("")
          .map((d) => singleDigits[parseInt(d)])
          .join(" ");
    }

    return result || "Zero";
  };

  const htmlToPDF = async (componentRef) => {
    const element = componentRef.current;
    const options = {
      margin: 0.5,
      filename: "payslip.pdf",
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2, useCORS: true },
      jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
    };

    try {
      const pdfBlob = await html2pdf()
        .from(element)
        .set(options)
        .output("blob");
      return pdfBlob;
    } catch (error) {
      console.error("Error generating PDF", error);
      return null;
    }
  };

  const handleDownload = async () => {
    const blob = await htmlToPDF(receptRef);
    if (blob) {
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = "payslip.pdf";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    }
  };
  return (
    <Modal
      open={open}
      onClose={() => setOpen(false)}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={{
          background: "white",
          overflowY: "auto",
          width: { xs: "90%", sm: "40%", md: "40%", lg: "30%", xl: "30%" },

          borderRadius: "10px",
          // height: "80vh",
          position: "absolute",
          left: { xs: "2%", sm: "25%", md: "35%", lg: "35%", xl: "35%" },

          top: "10%",
          paddingX: "10px",
        }}
      >
        {/* <ModalHeader
          title={"Salary Slip"}
          onClose={(data) => {
            setOpen(data);
          }}
        /> */}

        <DialogTitle
          color="primary"
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            fontWeight: "bold",
            padding: "10px 15px",
            fontSize: { xs: "12px", sm: "13px", md: "20px" },
          }}
        >
          Salary Slip{" "}
          <CloseIcon
            sx={{
              float: "right",
              color: "#000000",
              fontSize: { xs: "14px", sm: "13px", md: "30px" },
              cursor: "pointer",
            }}
            onClick={() => setOpen(false)}
          />
        </DialogTitle>

        {/* <Divider /> */}
        {/* <Grid container sx={{ position: "relative", p: "10px" }}>
          <Grid item xs={12}>
            <Typography
              color="primary"
              sx={{ marginRight: "10px", fontWeight: "800" }}
            >
              Payment Slipt for The Month Februwary
            </Typography>
          </Grid>
          <Grid item xs={12} sx={{ display: "flex" }}>
            <Typography color="primary" sx={{ marginRight: "20px" }}>
              Name
            </Typography>
            <Typography> {modalData?.emaployeeName}</Typography>
          </Grid>
          <Grid item xs={12} sx={{ display: "flex" }}>
            <Typography color="secondary" sx={{ marginRight: "10px" }}>
              Joining Date
            </Typography>
            <Typography></Typography>
          </Grid>
          <Grid item xs={12} sx={{ display: "flex" }}>
            <Typography color="secondary" sx={{ marginRight: "10px" }}>
              Designation
            </Typography>
            <Typography> </Typography>
          </Grid>
          <Grid item xs={12} sx={{ display: "flex" }}>
            <Typography color="secondary" sx={{ marginRight: "10px" }}>
              Location
            </Typography>
            <Typography> </Typography>
          </Grid>
          <Grid item xs={12} sx={{ display: "flex" }}>
            <Typography color="secondary" sx={{ marginRight: "10px" }}>
              Emp ID
            </Typography>
            <Typography>{modalData?.employeeId}</Typography>
          </Grid>
          <Grid
            item
            xs={12}
            sx={{ display: "flex", justifyContent: "space-between" }}
          >
            <Typography
              color="secondary"
              sx={{ marginRight: "10px", fontWeight: "800" }}
            >
              Earning
            </Typography>
            <Typography
              color="secondary"
              sx={{ marginRight: "10px", fontWeight: "800" }}
            >
              Actual
            </Typography>
          </Grid>
          <Grid
            item
            xs={12}
            sx={{ display: "flex", justifyContent: "space-between" }}
          >
            <Typography color="secondary" sx={{ marginRight: "10px" }}>
              Incentive Amount
            </Typography>
            <Typography sx={{ marginRight: "10px" }}>
              {modalData?.incentiveAmount}
            </Typography>
          </Grid>{" "}
          <Grid
            item
            xs={12}
            sx={{ display: "flex", justifyContent: "space-between" }}
          >
            <Typography color="secondary" sx={{ marginRight: "10px" }}>
              Total Earning: INR
            </Typography>
            <Typography sx={{ marginRight: "10px" }}>
              {modalData?.totalEarnings}
            </Typography>
          </Grid>
          <Grid
            item
            xs={12}
            sx={{ display: "flex", justifyContent: "space-between" }}
          >
            <Typography
              color="secondary"
              sx={{ marginRight: "10px", fontWeight: "800" }}
            >
              Deduction
            </Typography>
            <Typography
              color="secondary"
              sx={{ marginRight: "10px", fontWeight: "800" }}
            >
              Actual
            </Typography>
          </Grid>
          <Grid
            item
            xs={12}
            sx={{ display: "flex", justifyContent: "space-between" }}
          >
            <Typography color="secondary" sx={{ marginRight: "10px" }}>
              Advance Paid
            </Typography>
            <Typography sx={{ marginRight: "10px" }}>
              {modalData?.advancePaid}
            </Typography>
          </Grid>
          <Grid
            item
            xs={12}
            sx={{ display: "flex", justifyContent: "space-between" }}
          >
            <Typography color="secondary" sx={{ marginRight: "10px" }}>
              Total Deduction INR
            </Typography>
            <Typography sx={{ marginRight: "10px" }}>
              {modalData?.totalDeductions}
            </Typography>
          </Grid>
          <Grid
            item
            xs={12}
            sx={{ display: "flex", justifyContent: "space-between" }}
          >
            <Typography
              color="primary"
              sx={{ marginRight: "10px", fontWeight: "800" }}
            >
              Net Pay for the month (Total Earnings - Total Decduction):
            </Typography>
            <Typography
              color="primary"
              sx={{ marginRight: "10px", fontWeight: "800" }}
            >
              0.0
            </Typography>
          </Grid>
        </Grid> */}

        <Card sx={{ maxWidth: 600, mx: "auto", boxShadow: "none" }}>
          <CardContent>
            <Grid container>
              <Grid item xs={12}>
                <Typography
                  color="primary"
                  sx={{
                    fontWeight: "600",
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                  }}
                >
                  Payslip for the month of{" "}
                  {modalData?.fromDate
                    ? new Date(modalData.fromDate).toLocaleString("en-US", {
                        month: "long",
                        year: "numeric",
                      })
                    : "N/A"}
                </Typography>
              </Grid>

              <Grid
                item
                xs={12}
                sx={{
                  display: "flex",
                  gap: 1,
                  mt: 1,
                  justifyContent: "space-between",
                }}
              >
                <Typography
                  color="primary"
                  sx={{
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    fontWeight: "medium",
                  }}
                >
                  Name
                </Typography>
                <Typography
                  sx={{
                    fontWeight: "600",
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                  }}
                >
                  {modalData?.emaployeeName || "N/A"}
                </Typography>
              </Grid>

              <Grid
                item
                xs={12}
                sx={{
                  display: "flex",
                  gap: 1,
                  justifyContent: "space-between",
                }}
              >
                <Typography
                  color="primary"
                  sx={{
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    fontWeight: "medium",
                  }}
                >
                  Joining Date
                </Typography>
                <Typography
                  sx={{ fontSize: { xs: "12px", sm: "13px", md: "15px" } }}
                >
                  {modalData?.fromDate
                    ? (() => {
                        const date = new Date(modalData.doj);
                        const day = date.getDate().toString().padStart(2, "0");
                        const month = date.toLocaleString("en-US", {
                          month: "long",
                        });
                        const year = date.getFullYear();
                        return `${day} ${month} ${year}`;
                      })()
                    : "N/A"}
                </Typography>
              </Grid>

              {/* <Grid item xs={12} sx={{ display: "flex", gap: 1 }}>
                <Typography color="primary">Designation:</Typography>
                <Typography>{modalData?.designation || "N/A"}</Typography>
              </Grid> */}

              <Grid
                item
                xs={12}
                sx={{
                  display: "flex",
                  gap: 1,
                  justifyContent: "space-between",
                }}
              >
                <Typography
                  color="primary"
                  sx={{
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    fontWeight: "medium",
                  }}
                >
                  Location
                </Typography>
                <Typography
                  sx={{ fontSize: { xs: "12px", sm: "13px", md: "15px" } }}
                >
                  {modalData?.location || "N/A"}
                </Typography>
              </Grid>

              <Grid
                item
                xs={12}
                sx={{
                  display: "flex",
                  gap: 1,
                  justifyContent: "space-between",
                }}
              >
                <Typography
                  color="primary"
                  sx={{
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    fontWeight: "medium",
                  }}
                >
                  Emp ID
                </Typography>
                <Typography
                  sx={{ fontSize: { xs: "12px", sm: "13px", md: "15px" } }}
                >
                  {modalData?.employeeId || "N/A"}
                </Typography>
              </Grid>

              <Grid
                item
                xs={12}
                display={"flex"}
                justifyContent={"space-between"}
                sx={{ borderTop: "2px dotted #000000", py: 1 }}
              >
                <Typography
                  color="primary"
                  sx={{
                    fontWeight: "800",

                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                  }}
                >
                  Earnings
                </Typography>
                <Typography
                  color="primary"
                  sx={{
                    fontWeight: "800",
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                  }}
                >
                  Actual
                </Typography>
              </Grid>

              <Grid
                item
                xs={12}
                sx={{ display: "flex", justifyContent: "space-between" }}
              >
                <Typography
                  color="primary"
                  sx={{
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    fontWeight: "medium",
                  }}
                >
                  Incentive Amount
                </Typography>
                <Typography fontSize={{ xs: "12px", sm: "13px", md: "15px" }}>
                  ₹ {modalData?.paymentPercentageAmount || "0.00"}
                </Typography>
              </Grid>

              <Grid
                item
                xs={12}
                sx={{ display: "flex", justifyContent: "space-between" }}
              >
                <Typography
                  color="primary"
                  sx={{
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    fontWeight: "medium",
                  }}
                >
                  Total Earning (INR)
                </Typography>
                <Typography fontSize={{ xs: "12px", sm: "13px", md: "15px" }}>
                  ₹ {modalData?.paymentPercentageAmount || "0.00"}
                </Typography>
              </Grid>

              <Grid
                item
                xs={12}
                display={"flex"}
                justifyContent={"space-between"}
                sx={{ borderTop: "2px dotted #000000", py: 1 }}
              >
                <Typography
                  color="primary"
                  sx={{
                    fontWeight: "800",
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                  }}
                >
                  Deductions
                </Typography>
                <Typography
                  color="primary"
                  sx={{
                    fontWeight: "800",
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                  }}
                >
                  Actual
                </Typography>
              </Grid>

              <Grid
                item
                xs={12}
                sx={{ display: "flex", justifyContent: "space-between" }}
              >
                <Typography
                  color="primary"
                  sx={{
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    fontWeight: "medium",
                  }}
                >
                  Deduction
                </Typography>
                <Typography fontSize={{ xs: "12px", sm: "13px", md: "15px" }}>
                  ₹ {modalData?.deduction || "0.00"}
                </Typography>
              </Grid>
              <Grid
                item
                xs={12}
                sx={{ display: "flex", justifyContent: "space-between" }}
              >
                <Typography
                  color="primary"
                  sx={{
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    fontWeight: "medium",
                  }}
                >
                  Advance Paid
                </Typography>
                <Typography fontSize={{ xs: "12px", sm: "13px", md: "15px" }}>
                  ₹ {modalData?.advancePaid || "0.00"}
                </Typography>
              </Grid>

              <Grid
                item
                xs={12}
                sx={{ display: "flex", justifyContent: "space-between" }}
              >
                <Typography
                  color="primary"
                  sx={{
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    fontWeight: "medium",
                  }}
                >
                  Total Deductions: INR
                </Typography>
                <Typography fontSize={{ xs: "12px", sm: "13px", md: "15px" }}>
                  ₹{" "}
                  {(
                    (parseFloat(modalData?.deduction) || 0) +
                    (parseFloat(modalData?.advancePaid) || 0)
                  )}
                </Typography>
              </Grid>

              <Grid
                item
                xs={12}
                sx={{ py: 1, display: "flex", justifyContent: "space-between" }}
              >
                <Grid>
                  <Typography
                    color="primary"
                    sx={{
                      fontWeight: "800",
                      fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    }}
                  >
                    Net Pay for the Month
                  </Typography>
                  <Typography
                    color="primary"
                    sx={{ fontSize: { xs: "12px", sm: "13px", md: "15px" } }}
                  >
                    (Total Earnings - Total Deduction)
                  </Typography>
                </Grid>
                <Grid>
                  <Typography
                    color="primary"
                    sx={{
                      fontWeight: "800",
                      textAlign: "center",
                      fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    }}
                  >
                    {modalData?.amount || "0.00"}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
            <Box sx={{ display: "flex", justifyContent: "center" }}>
              <Button
                variant="contained"
                sx={{
                  width: "60%",
                  fontSize: { xs: "12px", sm: "13px", md: "15px" },
                }}
                onClick={handleDownload}
              >
                Download
              </Button>
            </Box>
          </CardContent>
        </Card>

        <Card
          sx={{
            maxWidth: 800,
            mx: "auto",
            p: 2,
            position: "fixed",
            top: 0,
            left: 0,
            opacity: 0,
            pointerEvents: "none",
            zIndex: -999,
          }}
        >
          <Box
            ref={receptRef}
            sx={{ position: "relative", minHeight: "1000px", mx: "auto" }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                px: 2,
                pt: 2,
                flexDirection: "row",
              }}
            >
              <Typography
                sx={{
                  fontWeight: "bold",
                  fontSize: "18px",
                  textAlign: "center",
                  flexGrow: 1,
                }}
              >
                {actvieBussinessDetails?.enterpriseName || "PALACE THE SALON"}
              </Typography>
              <Box
                component="img"
                src={actvieBussinessDetails?.logoPath}
                sx={{ width: 100, height: 100, borderRadius: "50%" }}
              />
            </Box>

            <Typography
              sx={{
                fontSize: "18px",
                fontWeight: 700,
                textAlign: "center",
                mt: 1,
              }}
            >
              Payslip for the month of{" "}
              {modalData?.fromDate
                ? new Date(modalData.fromDate).toLocaleString("en-US", {
                    month: "long",
                    year: "numeric",
                  })
                : "N/A"}
            </Typography>

            <Box sx={{ border: "3px solid black", borderRadius: "3px", mt: 2 }}>
              <Box
                sx={{
                  display: "flex",
                  borderBottom: "3px solid black",
                  width: "fit-content",
                }}
              >
                {/* Left Section */}
                <Box
                  sx={{
                    borderRight: "3px solid black",
                    padding: 1,
                    minWidth: 200,
                  }}
                >
                  <Grid container>
                    <Grid item xs={5}>
                      <Typography sx={{ fontSize: "16px", fontWeight: "500" }}>
                        Name:
                      </Typography>
                    </Grid>
                    <Grid item xs={7}>
                      <Typography sx={{ fontSize: "16px", fontWeight: "500" }}>
                        {modalData?.emaployeeName || "N/A"}
                      </Typography>
                    </Grid>

                    <Grid item xs={5} sx={{ mt: 1 }}>
                      <Typography sx={{ ffontSize: "16px", fontWeight: "500" }}>
                        Join Date:
                      </Typography>
                    </Grid>
                    <Grid item xs={7} sx={{ mt: 1 }}>
                      <Typography sx={{ fontSize: "16px", fontWeight: "500" }}>
                        {modalData?.doj
                          ? new Date(modalData.doj).toLocaleDateString(
                              "en-GB",
                              {
                                day: "2-digit",
                                month: "long",
                                year: "numeric",
                              }
                            )
                          : "N/A"}
                      </Typography>
                    </Grid>
                  </Grid>
                </Box>

                {/* Right Section */}
                <Box sx={{ padding: 1 }}>
                  <Grid container>
                    <Grid item xs={5}>
                      <Typography sx={{ fontSize: "16px", fontWeight: "500" }}>
                        Location:
                      </Typography>
                    </Grid>
                    <Grid
                      item
                      xs={7}
                      sx={{ justifyContent: "space-around", display: "flex" }}
                    >
                      <Typography sx={{ fontSize: "16px", fontWeight: "500" }}>
                        {modalData?.location || "N/A"}
                      </Typography>
                    </Grid>

                    <Grid item xs={5} sx={{ mt: 1 }}>
                      <Typography sx={{ fontSize: "16px", fontWeight: "500" }}>
                        Days In Month:
                      </Typography>
                    </Grid>
                    <Grid
                      item
                      xs={7}
                      sx={{
                        mt: 1,
                        justifyContent: "space-around",
                        display: "flex",
                      }}
                    >
                      <Typography sx={{ ffontSize: "16px", fontWeight: "500" }}>
                        0
                      </Typography>
                    </Grid>

                    <Grid item xs={5} sx={{ mt: 1 }}>
                      <Typography sx={{ fontSize: "16px", fontWeight: "500" }}>
                        Emp ID:
                      </Typography>
                    </Grid>
                    <Grid
                      item
                      xs={7}
                      sx={{
                        mt: 1,
                        justifyContent: "space-around",
                        display: "flex",
                      }}
                    >
                      <Typography sx={{ fontSize: "16px", fontWeight: "500" }}>
                        {modalData?.employeeId || "N/A"}
                      </Typography>
                    </Grid>
                  </Grid>
                </Box>
              </Box>

              {/* Earnings and Deductions */}
              <Grid container sx={{ padding: "3px" }}>
                <Grid
                  item
                  xs={6}
                  sx={{ display: "flex", justifyContent: "space-between" }}
                >
                  <Typography sx={{ fontSize: "16px", fontWeight: "500" }}>
                    Total Earnings: INR.
                  </Typography>
                  <Typography sx={{ fontSize: "16px", fontWeight: "500" }}>
                    {parseFloat(
                      modalData?.paymentPercentageAmount || "0.00"
                    ).toFixed(2)}
                  </Typography>
                </Grid>
              </Grid>
              <Grid container sx={{ padding: "3px" }}>
                <Grid
                  item
                  xs={6}
                  sx={{ display: "flex", justifyContent: "space-between" }}
                >
                  <Typography sx={{ fontSize: "16px", fontWeight: "500" }}>
                    Total Deductions: INR.
                  </Typography>
                  <Typography sx={{ fontSize: "16px", fontWeight: "500" }}>
                    {(
                      (parseFloat(modalData?.deduction) || 0) +
                      (parseFloat(modalData?.advancePaid) || 0)
                    ).toFixed(2)}
                  </Typography>
                </Grid>
              </Grid>

              <Divider sx={{ borderBottom: "3px solid black" }} />

              {/* Net Pay */}
              <Grid container sx={{ padding: "3px", mt: 1 }}>
                <Grid
                  item
                  xs={12}
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "flex-start",
                  }}
                >
                  <Box>
                    <Typography sx={{ fontWeight: "bold" }}>
                      Net Pay for the month
                    </Typography>
                    <Typography sx={{ fontWeight: "bold" }}>
                      (Total Earnings - Total Deductions): &nbsp;
                      <span> ₹ {modalData?.amount || "0.00"}</span>
                    </Typography>
                  </Box>

                  {/* <Typography sx={{ fontWeight: "bold", fontSize: "16px" }}>
        ₹ {modalData?.amount || "0.00"}
      </Typography> */}
                </Grid>

                <Grid item xs={12} sx={{ marginTop: "10px" }}>
                  <Typography>
                    ({convertNumberToWords(modalData?.amount || 0)})
                  </Typography>
                </Grid>
              </Grid>
            </Box>

            <Box
              sx={{
                position: "absolute",
                bottom: 10,
                left: 0,
                right: 0,
                textAlign: "center",
                fontFamily: "cursive",
              }}
            >
              <Typography
                variant="subtitle1"
                sx={{
                  fontWeight: "bold",
                  fontSize: { xs: "12px", sm: "13px", md: "15px" },
                }}
              >
                PALACE THE SALON -{" "}
                <span style={{ fontStyle: "italic" }}>Wakadewadi</span>
              </Typography>
              <Typography
                variant="body2"
                sx={{ fontWeight: 500, fontSize: "13px", fontStyle: "italic" }}
              >
                palacethesalon@gmail.com
              </Typography>
            </Box>
          </Box>
        </Card>
      </Box>
    </Modal>
  );
};
